import { Button, List, ListItem, ListItemText, ListSubheader, TextField } from "@material-ui/core";

const LexBotsList = ({
	filterBotName,
	setFilterBotName,
	setAssociatedFilter,
	associatedFilter,
	searchMatches,
	selectedBotId,
	botDetailsLoading,
	setSelectedBot,
	setSelectedBotId,
}) => {
	return (
		<List
			component="nav"
			subheader={
				<ListSubheader disableSticky component="div">
					<div style={{ marginBottom: 8 }}>
						<TextField
							autoComplete="off"
							label="Filter By Bot Name"
							value={filterBotName}
							style={{ width: "100%" }}
							size="small"
							onChange={(event) => {
								setFilterBotName(event.target.value);
							}}
						/>
					</div>

					<div className="d-flex flex-row justify-content-between flex-align-items-center flex-wrap">
						<span>Lex Bots</span>
						<Button
							variant="outlined"
							className="my-lg-auto mb-2 h"
							size="small"
							style={{ height: "fit-content" }}
							onClick={() => setAssociatedFilter(!associatedFilter)}
						>
							{associatedFilter ? "Show All" : "Show Only Associated"}
						</Button>
					</div>
				</ListSubheader>
			}
		>
			{searchMatches?.length && searchMatches.length > 0 ? (
				searchMatches.map((bot) => (
					<ListItem
						key={bot.botId}
						selected={bot.botId === selectedBotId}
						button
						disabled={botDetailsLoading}
						onClick={() => {
							setSelectedBot(bot);
							setSelectedBotId(bot.botId);
						}}
					>
						<ListItemText
							style={{ wordBreak: "break-word" }}
							primary={bot.botName}
							secondary={bot.associated ? <span style={{ color: "gray" }}>Associated Aliases</span> : ""}
						></ListItemText>
					</ListItem>
				))
			) : (
				<ListItem>
					<div className="text-muted">No lex bots found.</div>
				</ListItem>
			)}
		</List>
	);
};

export default LexBotsList;
